/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ProspectEmailFailure {
  unknown_outcome = 'unknown_outcome',
  retry_exhausted = 'retry_exhausted',
  gmail_disconnected = 'gmail_disconnected',
  not_contactable = 'not_contactable',
  rejected = 'rejected'
}
